export const operateList = [
  {
    icon: 'el-icon-rank',
    content: '移动',
    type: 'move'
  },
  {
    icon: 'el-icon-copy-document',
    content: '复制',
    type: 'copy'
  },
  {
    icon: 'el-icon-delete',
    content: '删除',
    type: 'delete'
  }
]
